import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

interface AmbienteBanner {
  rotulo: string;
  classe: 'dev' | 'hml';
}

/** Ambientes que exibem a barra; produção (e a suíte E2E) ficam sem ela. */
const BANNERS: Record<string, AmbienteBanner> = {
  local: { rotulo: 'Ambiente de Desenvolvimento (Local)', classe: 'dev' },
  dev: { rotulo: 'Ambiente de Desenvolvimento', classe: 'dev' },
  hml: { rotulo: 'Ambiente de Homologação (UAT)', classe: 'hml' },
};

const ALTURA_PX = 28;

@Component({
  selector: 'app-ambiente-banner',
  standalone: true,
  templateUrl: './ambiente-banner.component.html',
  styleUrls: ['./ambiente-banner.component.css']
})
export class AmbienteBannerComponent {
  readonly banner: AmbienteBanner | null = BANNERS[environment.name] ?? null;

  constructor() {
    // Layouts com position: fixed (header/sidebar) se deslocam por esta variável.
    document.documentElement.style.setProperty('--env-bar-height', this.banner ? `${ALTURA_PX}px` : '0px');
  }
}
